import PiecesGrid from "./PiecesGrid";

export default PiecesGrid;
